import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import "../components/privacy-policy.css"
import Header from "../components/header"
import NotFound from "../pages/404"

function PrivacyPage() {
  return (
    <Layout>
      <Seo
        title="Política de privacidad"
        path="/privacy-policy"
        description="Cómo tratamos y protegemos tus datos personales."
      />
      <Header showCollapsed={true} />
      <div className="PrivacyPolicy">
        <h1>POLÍTICA DE PRIVACIDAD</h1>
        <h3>Introducción</h3>
        <p>
          {process.env.GATSBY_platformCompanyName} te informa sobre su Política
          de Privacidad respecto del tratamiento y protección de los datos de
          carácter personal de los usuarios y clientes que puedan ser recabados
          por la navegación o contratación de servicios a través del sitio Web{" "}
          {process.env.GATSBY_platformWebSite}.
          <br />
          <br />
          En este sentido, el Titular garantiza el cumplimiento de la normativa
          vigente en materia de protección de datos personales, reflejada en la
          Ley de Protección de Datos en México, cuenta con una ley que regula el
          tratamiento de los datos personales por parte de empresas del sector
          privado desde el 5 de julio de 2010, esa ley se llama Ley Federal de
          Protección de Datos Personales en Posesión de los Particulares o Ley
          de Protección de Datos. Están obligadas por la Ley de Protección de
          Datos en México todas las empresas del sector privado que obtengan,
          usen, almacenen y/o transfieran datos personales como parte de sus
          actividades.
          <br />
          <br />
          Sumadas, estas acciones reciben el nombre de "tratamiento de datos
          personales”. Su aplicación determina que se evite que los datos
          personales sean utilizados indebidamente, que se respeten los derechos
          de los dueños de los datos y que se garantice una expectativa
          razonable de privacidad. Quienes traten datos personales deben tomar
          en cuenta las guías y documentos emitidos por el Instituto Nacional de
          Transparencia, Acceso a la Información y Protección de Datos
          Personales ("INAI"). El uso de sitio Web implica la aceptación de esta
          Política de Privacidad así como las condiciones incluidas en el Aviso
          Legal.
        </p>
        <p>
          <br />
          <span>IDENTIDAD DEL RESPONSABLE</span>
          <br />
          Titular: {process.env.GATSBY_platformCompanyName}
          <br />
          Correo electrónico: {process.env.GATSBY_platformEmail}
          <br />
          Sitio Web: {process.env.GATSBY_platformWebSite}
          <br />
          <br />
        </p>
        <p>
          De acuerdo con la Ley, los principales actores en el tratamiento de
          los datos personales son el "responsable" y el "encargado".
          <br />
          <span>Responsable:</span> es la persona del sector privado que toma
          las decisiones sobre el tratamiento de datos personales.
          <br />
          <span>Encargado:</span> es la persona ajena al responsable, que trata
          los datos personales por cuenta del responsable y de acuerdo con sus
          instrucciones.
          <br />
          Para aplicar la ley que protege a los datos de los usuarios, son
          establecidos algunos principios por la Ley de Protección de Datos, son
          ellos:
        </p>
        <p>
          <span>1) Licitud: </span> deberá cumplirse la Ley de Protección de
          Datos, su Reglamento y cualquier otra regulación aplicable al tratar
          los datos;
          <br />
          <span>2) Consentimiento: </span> siempre que sea necesario deberá
          obtenerse el consentimiento de los titulares para el tratamiento de
          sus datos personales;
          <br />
          <span>3) Información: </span> debe ser de conocimiento del titular la
          información relacionada con el tratamiento de sus datos;
          <br />
          <span>4) Calidad:todos </span> los datos personales recolectados deben
          ser exactos, completos, pertinentes, correctos y actualizados de
          acuerdo con sus finalidades;
          <br />
          <span>5) Finalidad: </span> el tratamiento de datos debe cumplir las
          finalidades establecidas en el aviso de privacidad presentado al
          usuario;
          <br />
          <span>6) Lealtad: proteger </span> los intereses del titular y la
          expectativa razonable de privacidad al tratar los datos personales;
          <br />
          <span>7) Proporcionalidad: </span> sólo los datos personales
          necesarios, adecuados y relevantes en relación con las finalidades
          podrán ser tratados;
          <br />
          <span>8) Responsabilidad: </span> la empresa debe responder por el
          tratamiento de los datos personales recolectados.
        </p>
        <h3>Obtencion de datos Personales</h3>
        <p>
          Para navegar por {process.env.GATSBY_platformCompanyName} no es
          necesario que facilites ningún dato personal. Los casos en los que sí
          proporcionas tus datos personales son los siguientes:
          <br />
          <br />
          <li>
            Al contactar a través de los formularios de contacto o enviar un
            correo electrónico.
          </li>
        </p>
        <h3>Tus Derechos</h3>
        <p>
          El Titular te informa que sobre tus datos personales tienes derecho a:
          <br />
          <br />
          <li>Solicitar el acceso a los datos almacenados.</li>
          <li>Solicitar una rectificación o la cancelación.</li>
          <li>Solicitar la limitación de su tratamiento.</li>
          <li>Oponerte al tratamiento.</li>
          <li>Solicitar la portabilidad de tus datos.</li>
          <br />
          <br />
          El ejercicio de estos derechos es personal y por tanto debe ser
          ejercido directamente por el interesado, solicitándolo directamente al
          Titular, lo que significa que cualquier cliente, suscriptor o
          colaborador que haya facilitado sus datos en algún momento puede
          dirigirse al Titular y pedir información sobre los datos que tiene
          almacenados y cómo los ha obtenido, solicitar la rectificación de los
          mismos, solicitar la portabilidad de sus datos personales, oponerse al
          tratamiento, limitar su uso o solicitar la cancelación de esos datos
          en los ficheros del Titular.
          <br />
          <br />
          Para ejercitar tus derechos de acceso, rectificación, cancelación,
          portabilidad y oposición tienes que enviar un correo electrónico a{" "}
          {process.env.GATSBY_platformCompanyName} junto con la prueba válida en
          derecho como una fotocopia del D.N.I. o equivalente.
          <br />
          <br />
          Tienes derecho a la tutela judicial efectiva y a presentar una
          reclamación ante la autoridad de control, en este caso, si consideras
          que el tratamiento de datos personales que te conciernen infringe el
          Reglamento.
          <br />
          <br />
        </p>
        <h3>Finalidad del tratamiento de datos personales</h3>
        <p>
          Cuando te conectas al sitio Web para mandar un correo al Titular, te
          suscribes a su boletín o realizas una contratación, estás facilitando
          información de carácter personal de la que el responsable es el
          Titular. Esta información puede incluir datos de carácter personal
          como pueden ser tu dirección IP, nombre y apellidos, dirección física,
          dirección de correo electrónico, número de teléfono, y otra
          información. Al facilitar esta información, das tu consentimiento para
          que tu información sea recopilada, utilizada, gestionada y almacenada{" "}
          {process.env.GATSBY_platformCompanyName}, sólo como se describe en el
          Aviso Legal y en la presente Política de Privacidad.
          <br />
          <br />
          Los datos personales y la finalidad del tratamiento por parte del
          Titular son diferentes según el sistema de captura de información:
          <br />
          <br />
          <li>
            Formularios de contacto: El Titular solicita datos personales entre
            los que pueden estar: Nombre y apellidos, dirección de correo
            electrónico, número de teléfono y dirección de tu sitio Web con la
            finalidad de responder a tus consultas. Por ejemplo, el Titular
            utiliza esos datos para dar respuesta a tus mensajes, dudas, quejas,
            comentarios o inquietudes que puedas tener relativas a la
            información incluida en el sitio Web, los servicios que se prestan a
            través del sitio Web, el tratamiento de tus datos personales,
            cuestiones referentes a los textos legales incluidos en el sitio
            Web, así como cualquier otra consulta que puedas tener y que no esté
            sujeta a las condiciones del sitio Web o de la contratación.
          </li>
          <li>
            Para garantizar el cumplimiento de las condiciones recogidas en el
            Aviso Legal y en la ley aplicable. Esto puede incluir el desarrollo
            de herramientas y algoritmos que ayuden a este sitio Web a
            garantizar la confidencialidad de los datos personales que recoge.
          </li>
          <li>
            Para apoyar y mejorar los servicios que ofrecen en su sitio Web.
          </li>
          <li>
            Para analizar la navegación. El Titular recoge otros datos no
            identificativos que se obtienen mediante el uso de cookies que se
            descargan en tu ordenador cuando navegas por el sitio Web cuyas
            características y finalidad están detalladas en la Política de
            Cookies .
          </li>
          {/* <li>
            Para gestionar las redes sociales. El Titular tiene presencia en
            redes sociales. Si te haces seguidor en las redes sociales del
            Titular el tratamiento de los datos personales se regirá por este
            apartado, así como por aquellas condiciones de uso, políticas de
            privacidad y normativas de acceso que pertenezcan a la red social
            que proceda en cada caso y que has aceptado previamente.
          </li> */}
          {/* ....................... */}
        </p>
        <h3>Seguridad de los datos personales</h3>
        <p>
          Para proteger tus datos personales, el Titular toma todas las
          precauciones razonables y sigue las mejores prácticas de la industria
          para evitar su pérdida, mal uso, acceso indebido, divulgación,
          alteración o destrucción de los mismos.
          <br />
          <br />
          El sitio Web está alojado en “POWERING YOU”. La seguridad de tus datos
          está garantizada, ya que toman todas las medidas de seguridad
          necesarias para ello. Puedes consultar su política de privacidad para
          tener más información. netliy.com
        </p>
        <h3>Contenido de otros sitios Web</h3>
        <p>
          Las páginas de este sitio Web pueden incluir contenido incrustado (por
          ejemplo, vídeos, imágenes, artículos, et.) . El contenido incrustado
          de otras web se comporta exactamente de la misma manera que si
          hubieras visitado la otra web.
          <br />
          <br />
          Estos sitios Web pueden recopilar datos sobre ti, utilizar cookies,
          incrustar un código de seguimiento adicional de terceros, y supervisar
          tu interacción usando este código.
        </p>
        <h3>Politicas de Cookies</h3>
        <p>
          Para que este sitio Web funcione correctamente necesita utilizar
          cookies, que es una información que se almacena en tu navegador web.
          <br />
          <br />
          En la página Política de Cookies puedes consultar toda la información
          relativa a la política de recogida, la finalidad y el tratamiento de
          las cookies.
        </p>
        <h3>Legitimacion para el tratamiento de Datos</h3>
        <p>
          La base legal para el tratamiento de tus datos es: el consentimiento.
          <br />
          <br />
          Para contactar con el Titular, suscribirte a un boletín o realizar
          comentarios en este sitio Web tienes que aceptar la presente Política
          de Privacidad.
        </p>
        <h3>Categorias de datos Personales</h3>
        <p>
          Las categorías de datos personales que trata el Titular son:
          <br />
          <br />
          <li>
            Datos identificativos: La Conservación de datos personales - Los
            datos personales que proporciones al Titular se conservarán hasta
            que solicites su supresión.
          </li>
        </p>
        <h3>Navegacion Web</h3>
        <p>
          Al navegar por dentro de las páginas web{" "}
          {process.env.GATSBY_platformCompanyName} se pueden recoger datos no
          identificativos, que pueden incluir, la dirección IP, geo
          localización, un registro de cómo se utilizan los servicios y sitios,
          hábitos de navegación y otros datos que no pueden ser utilizados para
          identificarte.
          <br />
          <br />
          El Titular utiliza la información obtenida para obtener datos
          estadísticos, analizar tendencias, administrar el sitio, estudiar
          patrones de navegación y para recopilar información demográfica.
        </p>
        <h4>Exactitud y veracidad de los datos personales</h4>
        <p>
          Te comprometes a que los datos facilitados al Titular sean correctos,
          completos, exactos y vigentes, así como a mantenerlos debidamente
          actualizados.
          <br />
          <br />
          Como Usuario del sitio Web eres el único responsable de la veracidad y
          corrección de los datos que remitas al sitio exonerando al Titular de
          cualquier responsabilidad al respecto.
        </p>
        <h3>Aceptacion y consentimiento</h3>
        <p>
          Como Usuario del sitio Web declaras haber sido informado de las
          condiciones sobre protección de datos de carácter personal, aceptas y
          consientes el tratamiento de los mismos por parte de el Titular en la
          forma y para las finalidades indicadas en esta Política de Privacidad.
        </p>
        <h3>Revocabilidad</h3>
        <p>
          Para ejercitar tus derechos de acceso, rectificación, cancelación,
          portabilidad y oposición tienes que enviar un correo electrónico a{" "}
          {process.env.GATSBY_platformEmail} junto con la prueba válida en
          derecho como una fotocopia del D.N.I. o equivalente.
          <br />
          <br />
          El ejercicio de tus derechos no incluye ningún dato que el Titular
          esté obligado a conservar con fines administrativos, legales o de
          seguridad.
        </p>
        <h3>Cambios en la Política de Privacidad</h3>
        <p>
          El Titular se reserva el derecho a modificar la presente Política de
          Privacidad para adaptarla a novedades legislativas o
          jurisprudenciales, así como a prácticas de la industria.
          <br />
          <br />
          Estas políticas estarán vigentes hasta que sean modificadas por otras
          debidamente publicadas.
        </p>
      </div>
    </Layout>
  )
}

export default process.env.GATSBY_isMainPlatform === "true"
  ? PrivacyPage
  : NotFound
